import axios from "axios";

export const state = {
    loanfines: [],
};

export const getters = {
    loanfines: (state) => state.loanfines,
};

export const mutations = {
    setLoanFines(state, newValue) {
        state.loanfines = newValue;
    },
};

export const actions = {
    async fetchLoanFines({ commit }) {
        await axios.get("/loan-fines").then((res) => {
            commit("setLoanFines", res.data.loan_fines);
        });
    },
};
